export default "__VITE_ASSET__DalOdAsr__"